import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule } from '@nebular/theme';
import { KPI } from '../../../@core/api'
import { DatePipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-workflow-comments-list-dialog',
    styleUrls: ['./workflow-comments-list-dialog.component.scss'],
    templateUrl: './workflow-comments-list-dialog.component.html',
    standalone: true,
    imports: [
    NbCardModule,
    FontAwesomeModule,
    DatePipe
],
})
export class WorkflowCommentsListDialogComponent implements OnInit {
  public commentTitle = this.translate.instant('pages.workflow.comments.add-comment-title');
  public comments: KPI.WorkflowRoundStepComment[] = [];

  constructor(
    private ref: NbDialogRef<WorkflowCommentsListDialogComponent>,
    private translate: TranslateService,
  ) { }

  public ngOnInit(): void {
  }

  public safeCommentText(comment: KPI.WorkflowRoundStepComment) : string {
    return comment.text.split('\n').join('<br />');
  }

  public exit(event) {
    event.preventDefault();
    this.ref.close()
  }

  protected readonly close = close
}
